var _path, _polygon, _path2, _g, _g2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M912,512c0,95.3-33.4,182.9-89,251.6c-46.1,57-107.6,101-178.1,125.8C603.3,904,558.6,912,512,912 s-91.3-8-132.8-22.6c-70.5-24.8-132-68.8-178.1-125.8c-55.7-68.7-89-156.3-89-251.6c0-1.2,0-2.5,0-3.7 c0.7-77.5,23.5-149.8,62.3-210.8c52.1-81.8,133.1-143.4,228.6-170.4c34.7-9.8,71.3-15.1,109.1-15.1c37.8,0,74.4,5.2,109.1,15.1 c95.5,27,176.5,88.6,228.6,170.4c38.9,61,61.6,133.3,62.3,210.8v0C912,509.5,912,510.8,912,512z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "512,379 372.2,480.6 425.6,645 598.4,645 651.8,480.6 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M651.8,195.3L512,268.6l-139.8-73.3l30.7-68.2c34.7-9.8,71.3-15.1,109.1-15.1c37.8,0,74.4,5.2,109.1,15.1 L651.8,195.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M276.5,444.8L163.6,555.1L112,508.3c0.7-77.5,23.5-149.8,62.3-210.8l75.7-8.3L276.5,444.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912,508.3L912,508.3l-51.6,46.8L747.5,444.8L774,289.2l75.7,8.3C888.5,358.5,911.3,430.8,912,508.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M442.9,853l-63.7,36.4c-70.5-24.8-132-68.8-178.1-125.8l15.6-75l156.2,22.9L442.9,853z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823,763.6c-46.1,57-107.6,101-178.1,125.8L581.1,853l70-141.5l156.2-22.9L823,763.6z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 372.2,
    y1: 480.6,
    x2: 276.5,
    y2: 444.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 512,
    y1: 379,
    x2: 512,
    y2: 268.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 747.5,
    y1: 444.8,
    x2: 651.8,
    y2: 480.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 651.1,
    y1: 711.5,
    x2: 598.4,
    y2: 645
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 372.9,
    y1: 711.5,
    x2: 425.6,
    y2: 645
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 442.9,
    y1: 853,
    x2: 581.1,
    y2: 853
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 807.3,
    y1: 688.6,
    x2: 860.4,
    y2: 555.1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 774,
    y1: 289.2,
    x2: 651.8,
    y2: 195.3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 372.2,
    y1: 195.3,
    x2: 244.3,
    y2: 289.8
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 163.6,
    y1: 555.1,
    x2: 216.7,
    y2: 688.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/Football.6cbe51a7f865f04341ee153b28c86bb2.svg";
export { ForwardRef as ReactComponent };